export default function Divider() {
  return (
    <>
      <div className="w-full h-2 bg-gray-200"></div>
    </>
  );
}
